import { Grid } from "@mui/material";
import React from "react";
import enquiryFollowupService from "../../services/enquiryFollowupService";
import enquiryService from "../../services/enquiryService";
import ApplicantStatsCard from "../manage-applications/dashboard-cards/applicantStatsCard";
import EnquiryWaitingCard from "../manage-enquiries/dashboard-cards/enquiryWaitingCard";
import EnquiryFollowUpStats from "../manage-enquiries/dashboard-cards/enquiryFollowUpStatsCard";
import EnquirySourceStatsCard from "../manage-enquiries/enquiry/enquirySourceStatsCard";
import EnquiryStatsCard from "../manage-enquiries/dashboard-cards/enquiryStatsCard";

class CounsellorDashboard extends React.Component {
  state = {
    enquiryStats: {},
    enquiryFollowupStats: {},
  };

  constructor() {
    super();
    this.getEnquiryStats();
    this.getEnquiryFollowupStats();
  }

  getEnquiryStats = async () => {
    try {
      const { data: enquiryStats } = await enquiryService.getStats();
      this.setState({ enquiryStats });
    } catch (error) {}
  };

  getEnquiryFollowupStats = async () => {
    try {
      const { data: enquiryFollowupStats } =
        await enquiryFollowupService.getStats();
      this.setState({ enquiryFollowupStats });
    } catch (error) {}
  };

  render() {
    const { enquiryStats, enquiryFollowupStats } = this.state;
    return (
      <React.Fragment>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={4}>
            <EnquiryStatsCard data={enquiryStats} />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <EnquiryFollowUpStats data={enquiryFollowupStats} />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <EnquirySourceStatsCard data={enquiryStats} />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={4}>
            <EnquiryWaitingCard />
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <ApplicantStatsCard />
          </Grid>
          {/* <Grid item xs={12} sm={12} md={4}>
            <EnquirySourceStatsCard data={enquiryStats} />
          </Grid> */}
        </Grid>
      </React.Fragment>
    );
  }
}

export default CounsellorDashboard;
